import React, { ComponentType } from 'react';
import { Route, Redirect, RouteComponentProps, RouteProps } from 'react-router-dom';
import { AuthContext, AuthContextType, ServicesContext } from '~/services';

interface ProtectedAdminRouteProps extends Omit<RouteProps, 'component'> {
    component: ComponentType<RouteComponentProps>;
}

// Type assertions for TypeScript 5.x compatibility with react-router-dom v5
const RouteComponent = Route as any;
const RedirectComponent = Redirect as any;

export function ProtectedAdminRoute({ component: Component, ...rest }: ProtectedAdminRouteProps) {
    const { authenticated } = React.useContext(AuthContext) as AuthContextType;
    const servicesContext = React.useContext(ServicesContext);
    return (
        <RouteComponent
            {...rest}
            render={(props: RouteComponentProps) =>
                authenticated === true &&
                (servicesContext.user.isGlobalAdmin() ||
                    servicesContext.user.isOrganizationAdmin() ||
                    servicesContext.user.isMACLAdmin() ||
                    servicesContext.user.isReportYearAdmin()) === true ? (
                    <Component {...props} />
                ) : (
                    <RedirectComponent
                        to={{
                            pathname: '/dashboard',
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
}
